module.exports = __webpack_public_path__ + "img/map.ded8cbe9.svg";